export default __webpack_public_path__ + "static/media/FundBulletin.83e2ca06.png";